// build a dynamic injector for each of the models!
// This creates a service that is capable of creating any given model
// It uses dynamic injection, to avoid a cuicular dependancy - as any model, needs to be able to create instances of other models
function BBModel() {
    'ngInject';
}

angular
    .module('BB')
    .service('BBModel', BBModel);




// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_models/bb_model.service.js